module.exports = __webpack_public_path__ + "static/media/underarmour_idm_tool.4d150e4b.jpg";